import { useContext, useState } from "react";
import { Grid } from "@mui/material";
import { useQuery, useQueryClient } from "react-query";
import { getUserDetails } from "../../services/Users";
import ChatSideBar from './ChatSideBar';
import { ACTIONS, WizardContext } from "../wizard/Context";
import ChatLayout from "./ChatLayout";

const ChatPane = ({ isFullScreen, position, setOffset, isDragging, setIsDragging }) => {
    const { dispatch } = useContext(WizardContext);
    const queryClient = useQueryClient();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    // Fetch user details
    const { data: userDetails } = useQuery(
        "getUserDetails",
        getUserDetails,
        {
            refetchOnWindowFocus: false,
        }
    );

    const handleNewChat = () => {
        queryClient.cancelMutations(["sendPrompt"]);

        dispatch({
            type: ACTIONS.UPDATE_CHAT_WINDOW,
            payload: {
                chatConfig: {
                    initiated: true, // Reset initiated to true for new chat
                }
            },
        });

        if (!isFullScreen) {
            setIsMenuOpen(false);
        }
    };

    return (
        <Grid
            sx={{
                marginTop: isFullScreen && '49.5px',
                backgroundColor: '#FFFFFF',
                maxWidth: isFullScreen ? '100%' : '480px',
                height: 'inherit',
                flexWrap: 'nowrap',
            }}
            container>

            {isFullScreen && <ChatSideBar
                isFullScreen={isFullScreen}
                isMenuOpen={isMenuOpen}
                setIsMenuOpen={setIsMenuOpen}
                handleNewChat={handleNewChat}
            />}

            <ChatLayout
                isFullScreen={isFullScreen}
                position={position}
                setOffset={setOffset}
                isDragging={isDragging}
                setIsDragging={setIsDragging}
                handleNewChat={handleNewChat}
                userDetails={userDetails}
            />
        </Grid>
    );
}

export default ChatPane;